import { GlobalStore } from "../../../store/global/GlobalStore";
import { WalletContentDisplayLocations } from "./ConnectedWalletButton";
import { Address } from "viem";
import { getAddressLabel } from "utils/userUtils";
import { withIsVisible } from "utils/reactUtils";
import { Text, TextStyle } from "components/general/Text";
import { PropsOf } from "@emotion/react";

export const WalletAddressLabel = withIsVisible(
  (props: { displayLocation: WalletContentDisplayLocations }) => {
    const address = GlobalStore.useState(s => s.address);
    const ensName = GlobalStore.useState(s => s.ensName);
    const theme = GlobalStore.useState(s => s.theme);

    const ADDRESS_STYLES: Record<
      WalletContentDisplayLocations,
      { textStyle: TextStyle; size: string; color?: string }
    > = {
      [WalletContentDisplayLocations.Sidenav]: {
        textStyle: "Title",
        size: "Medium",
      },
      [WalletContentDisplayLocations.Header]: { textStyle: "Title", size: "Small" },
      [WalletContentDisplayLocations.WalletView]: { textStyle: "Title", size: "Small" },
      [WalletContentDisplayLocations.NavbarV2]: {
        textStyle: "Title",
        size: "XXS",
        color: theme.theme[1700],
      },
      [WalletContentDisplayLocations.NavbarV2Mobile]: {
        color: theme.font.primary.default,
        textStyle: "Title",
        size: "XXS",
      },
    };

    if (address == null) {
      return null;
    }

    return (
      <Text
        textStyle={ADDRESS_STYLES[props.displayLocation].textStyle}
        size={ADDRESS_STYLES[props.displayLocation].size as PropsOf<typeof Text>["size"]}
        color={ADDRESS_STYLES[props.displayLocation].color}
        data-testid="wallet-address-label"
      >
        {getAddressLabel(address as Address, ensName)}
      </Text>
    );
  }
);
